import { useLocation } from 'react-router';

const noFormat = (e) => e;

export default (params, format = noFormat) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return params.map((p, i) => format(query.get(p), i));
};

export const useQueryMultiple = (params) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return params.reduce((acc, param) => {
    const value = query.getAll(param);
    acc[param] = value.length ? value : null;
    return acc;
  }, {});
};
